import {
  ActionType,
  ActionTypeCreate,
  ActionTypeDelete,
  ActionTypeUpdate,
  ActorTypeSystem,
  ActorTypeWeave,
  ObjectType,
  ObjectTypeCallBlocking,
  ObjectTypeCallRecording,
  ObjectTypeHoldMusic,
} from '@weave/schema-gen-ts/dist/apis/api/phone/audits/v1/api.pb';
import { i18next } from '@frontend/i18n';
import { IconName } from '@frontend/icons';

export const SETTING_TYPE_OPTIONS: { value: ObjectType; label: string }[] = [
  { value: ObjectTypeCallBlocking, label: i18next.t('Call Blocking', { ns: 'phone' }) },
  { value: ObjectTypeCallRecording, label: i18next.t('Call Recording', { ns: 'phone' }) },
  { value: ObjectTypeHoldMusic, label: i18next.t('Hold Music', { ns: 'phone' }) },
];

export const ACTION_TYPE_OPTIONS: { value: ActionType; label: string }[] = [
  { value: ActionTypeUpdate, label: i18next.t('Update', { ns: 'phone' }) },
  { value: ActionTypeCreate, label: i18next.t('Create', { ns: 'phone' }) },
  { value: ActionTypeDelete, label: i18next.t('Delete', { ns: 'phone' }) },
];

export const OBJECT_SETTINGS_PATH: Partial<
  Record<string, '/phone/call-blocking' | '/phone/call-recording' | '/phone/hold-music'>
> = {
  [ObjectTypeCallBlocking]: '/phone/call-blocking',
  [ObjectTypeCallRecording]: '/phone/call-recording',
  [ObjectTypeHoldMusic]: '/phone/hold-music',
};

export const SETTING_TYPE_LABELS: Partial<Record<string, { label: string; iconName: IconName; description: string }>> =
  {
    [ObjectTypeCallBlocking]: {
      label: i18next.t('Call Blocking', { ns: 'phone' }),
      iconName: 'phone-missed',
      description: i18next.t('View the history of phone numbers blocked and unblocked.', { ns: 'phone' }),
    },
    [ObjectTypeCallRecording]: {
      label: i18next.t('Call Recording', { ns: 'phone' }),
      iconName: 'record',
      description: i18next.t('View the history of Call Recording settings changes.', { ns: 'phone' }),
    },
    [ObjectTypeHoldMusic]: {
      label: i18next.t('Hold Music', { ns: 'phone' }),
      iconName: 'pause',
      description: i18next.t('View the history of changes to your hold music.', { ns: 'phone' }),
    },
  };

export type ActionChipVariant = 'eggplant' | 'primary' | 'critical' | 'warn';

export const ACTION_CHIP_CONFIG: Partial<Record<string, { label: string; variant: ActionChipVariant }>> = {
  [ActionTypeUpdate]: { label: i18next.t('Update', { ns: 'phone' }), variant: 'eggplant' },
  [ActionTypeCreate]: { label: i18next.t('Create', { ns: 'phone' }), variant: 'primary' },
  [ActionTypeDelete]: { label: i18next.t('Delete', { ns: 'phone' }), variant: 'critical' },
};

export const UNKNOWN_LABEL = i18next.t('Unknown', { ns: 'phone' });

// Values used in the userIds filter array to represent Weave actor types.
export const ACTOR_SYSTEM_OPTION = ActorTypeSystem;
export const ACTOR_WEAVE_OPTION = ActorTypeWeave;

export const USER_FILTER_OFFICE_STAFF_LIMIT = 25;

export const WEAVE_USER_LABEL = i18next.t('Weave Team', { ns: 'phone' });
